import { useState } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta12({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const [seleccionadas, setSeleccionada] = useState([]);
	const [btn1, setBtn1] = useState(false);
	const [btn2, setBtn2] = useState(false);
	const [btn3, setBtn3] = useState(false);
	const [btn4, setBtn4] = useState(false);
	const [correctas] = useState([
		'd) Investigar los hechos y reunir información del cliente y del Asesor.',
		'b) Brindar retroalimentación al Asesor sobre cómo mejorar su comunicación.',
		'a) Proponer una solución al cliente basada en datos claros y actualizados.',
		'c) Validar que el cliente esté satisfecho con la solución implementada.',
	]);
	const [paso1, setPaso1] = useState(null);
	const [paso2, setPaso2] = useState(null);
	const [paso3, setPaso3] = useState(null);
	const [paso4, setPaso4] = useState(null);
	const [pasos, setPasos] = useState(1);

	const grabarSeleccionada = (opc, btn) => {
		const array = seleccionadas;
		array.push(opc);
		setSeleccionada(array);
		setPasos(pasos + 1);

		if (btn === 1) {
			setPaso1(pasos);
		}
		if (btn === 2) {
			setPaso2(pasos);
		}
		if (btn === 3) {
			setPaso3(pasos);
		}
		if (btn === 4) {
			setPaso4(pasos);
		}
	};

	const siguiente = () => {
		if (seleccionadas.toString() === correctas.toString()) {
			setRespuesta('pregunta12', seleccionadas, 1);
			console.log('si');

			sumarPuntos(1);
		} else {
			setRespuesta('pregunta12', seleccionadas, 0);
			console.log('no');

			sumarPuntos(0);
		}
		cambiarPregunta(13);
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>12.</div> Un cliente importante se queja de que uno de tus asesores no le proporcionó información clara sobre los rendimientos de su Afore. ¿Cuál sería el mejor proceso para manejar este conflicto con el Asesor? Ordena los pasos
						</div>
					</Grid>
					<Grid item xs={11} sm={11} md={11} lg={11}>
						<div
							className={`${btn1 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn1(true);
								grabarSeleccionada('a) Proponer una solución al cliente basada en datos claros y actualizados.', 1);
							}}
						>
							<div className='letra'>{`a)`}</div>
							<div className='texto-respuesta'>Proponer una solución al cliente basada en datos claros y actualizados.</div>
						</div>
					</Grid>
					<Grid item xs={1} sm={1} md={1} lg={1}>
						<div className='num-pregunta'>{paso1}</div>
					</Grid>
					<Grid item xs={11} sm={11} md={11} lg={11}>
						<div
							className={`${btn2 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn2(true);
								grabarSeleccionada('b) Brindar retroalimentación al Asesor sobre cómo mejorar su comunicación.', 2);
							}}
						>
							<div className='letra'>{`b)`}</div>
							<div className='texto-respuesta'>Brindar retroalimentación al Asesor sobre cómo mejorar su comunicación.</div>
						</div>
					</Grid>
					<Grid item xs={1} sm={1} md={1} lg={1}>
						<div className='num-pregunta'>{paso2}</div>
					</Grid>
					<Grid item xs={11} sm={11} md={11} lg={11}>
						<div
							className={`${btn3 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn3(true);
								grabarSeleccionada('c) Validar que el cliente esté satisfecho con la solución implementada.', 3);
							}}
						>
							<div className='letra'>{`c)`}</div>
							<div className='texto-respuesta'> Validar que el cliente esté satisfecho con la solución implementada.</div>
						</div>
					</Grid>
					<Grid item xs={1} sm={1} md={1} lg={1}>
						<div className='num-pregunta'>{paso3}</div>
					</Grid>
					<Grid item xs={11} sm={11} md={11} lg={11}>
						<div
							className={`${btn4 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn4(true);
								grabarSeleccionada('d) Investigar los hechos y reunir información del cliente y del Asesor.', 4);
							}}
						>
							<div className='letra'>{`d)`}</div>
							<div className='texto-respuesta'> Investigar los hechos y reunir información del cliente y del Asesor.</div>
						</div>
					</Grid>
					<Grid item xs={1} sm={1} md={1} lg={1}>
						<div className='num-pregunta'>{paso4}</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
